var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "mb-4 text-xl font-bold" }, [
      _vm._v(_vm._s(_vm.$t("trial.activate.title")))
    ]),
    _c("p", { staticClass: "mb-4 text-xl" }, [
      _vm._v(_vm._s(_vm.$t("trial.activate.message")))
    ]),
    _c(
      "div",
      {
        staticClass: "d-flex justify-end align-center flex-wrap",
        staticStyle: { gap: "8px" }
      },
      [
        _c("va-button", {
          attrs: { type: "outline", cta: _vm.$t("trial.back") },
          on: {
            click: function($event) {
              return _vm.$emit("prev")
            }
          }
        }),
        _c("va-button", {
          attrs: { cta: _vm.$t("trial.activate.cta") },
          on: {
            click: function($event) {
              return _vm.$router.push("/activate")
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }